import { useCallback, useEffect, useState } from "react";

interface ITimeParams {
  createdAt: string;
  expireIn: number;
}

export function useCountdown() {
  const [{ createdAt, expireIn }, setCountdownInfo] = useState({
    createdAt: "",
    expireIn: 0,
  });
  const [timeLeft, setTimeLeft] = useState(expireIn);

  const formatTime = () => {
    const seconds = Math.floor((timeLeft / 1000) % 60);
    const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    return `${hours}h ${minutes}m ${seconds}s`;
  };

  const setDuration = (timeInfo: ITimeParams) => {
    setCountdownInfo(timeInfo);
  };

  const getRemainingTime = useCallback(
    (createdAt: string, expireIn: number) => {
      const currentTime = new Date().getTime();
      const createdTime = new Date(createdAt).getTime();
      const timeElapsed = currentTime - createdTime;
      return expireIn - timeElapsed;
    },
    []
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      const remainingTime = getRemainingTime(createdAt, expireIn);
      if (remainingTime <= 0) {
        clearInterval(intervalId);
        setTimeLeft(0);
      } else {
        setTimeLeft(remainingTime);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [createdAt, expireIn, getRemainingTime]);

  return {
    setDuration,
    timeLeft,
    formattedTime: formatTime(),
    getRemainingTime,
  };
}
